<template>
  <section ref="pc_common" :class="[
      'page-common', 
      customClassProp, 
      `detect_deviece_${deviceType}`, 
      `state_${deviceType}`,
      `theme-${domainConfig?.siteThemeColor || 1}`,
    ]">
    <AppHeader :class="[
      `app_device_detect_is_${deviceType}`, 
      `theme-${domainConfig?.siteThemeColor || 1}`
    ]" :headerTheme="headerTheme" />
    <slot :class="`theme-${domainConfig?.siteThemeColor || 1}`" />
    <!-- <FootBar /> -->

    <AppFooter />
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import AppFooter from '@/components/AppFooter'
import AppHeader from '@/components/AppHeader.vue'
export default {
  components: {
    AppHeader,
    AppFooter
  },
  props: {
    // 使用不同的prop名称避免与保留字冲突
    classs: {
      type: [String, Array, Object],
      default: ''
    },
    headerTheme: {
      type: String,
      default: 'light' // 默认为light主题
    },
    titlePrefix: {
      type: String,
      default: '' // 每个页面可以传入不同的标题前缀
    },
    metaDescription: {
      type: String,
      default: '' // 每个页面可以传入不同的描述
    }
  },
  computed: {
    ...mapGetters({
      deviceType: 'deviceType',
      domainConfig: 'domainConfig',
    }),
    customClassProp () {
      return this.classs
    },
    pageTitle () {
      const metaTitle = this.domainConfig?.['meta']?.title || 'Default Title';
      const prefix = this.resolveTitlePrefix();
      if (!prefix) return metaTitle;
      const needSpace = !/[|｜:–—-]$/.test(prefix);
      return `${prefix}${needSpace ? ' ' : ''}${metaTitle}`;
    },
    pageDescription () {
      return this.metaDescription || this.domainConfig?.['meta']?.des || 'Default des';
    }
  },
  methods: {
    resolveTitlePrefix () {
      const routeName = this.$route?.name || '';
      const routePrefixes = this.domainConfig?.titlePrefixByRoute || {};
      if (Object.prototype.hasOwnProperty.call(routePrefixes, routeName)) {
        return routePrefixes[routeName] || '';
      }
      if (/detail/i.test(routeName) && this.domainConfig?.detailTitleSuffix) {
        return `${this.titlePrefix}${this.domainConfig.detailTitleSuffix}`;
      }
      return this.titlePrefix;
    }
  },
  metaInfo () {
    return {
      title: this.pageTitle,
      meta: [
        {
          name: 'description',
          content: this.pageDescription,
        },
        {
          property: 'og:title',
          content: this.pageTitle,
        },
        {
          property: 'og:description',
          content: this.pageDescription,
        },
      ],
    }
  },
};
</script>
